/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { IObservableArray } from "mobx"
import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { CustomerOrderDtoModel, CustomerOrderDtoModelType } from "./CustomerOrderDtoModel"
import { CustomerOrderDtoModelSelector } from "./CustomerOrderDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  orders: IObservableArray<CustomerOrderDtoModelType>;
}

/**
 * CustomerOrdersResultDtoBase
 * auto generated base class for the model CustomerOrdersResultDtoModel.
 */
export const CustomerOrdersResultDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('CustomerOrdersResultDto')
  .props({
    __typename: types.optional(types.literal("CustomerOrdersResultDto"), "CustomerOrdersResultDto"),
    hasNextPage: types.union(types.undefined, types.boolean),
    orders: types.union(types.undefined, types.array(MSTGQLRef(types.late((): any => CustomerOrderDtoModel)))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class CustomerOrdersResultDtoModelSelector extends QueryBuilder {
  get hasNextPage() { return this.__attr(`hasNextPage`) }
  orders(builder: string | CustomerOrderDtoModelSelector | ((selector: CustomerOrderDtoModelSelector) => CustomerOrderDtoModelSelector) | undefined) { return this.__child(`orders`, CustomerOrderDtoModelSelector, builder) }
}
export function selectFromCustomerOrdersResultDto() {
  return new CustomerOrdersResultDtoModelSelector()
}

export const customerOrdersResultDtoModelPrimitives = selectFromCustomerOrdersResultDto().hasNextPage
